import logoImg from "../image/klara-queen-logo.png";

export const logoData = {
  src: logoImg,
  alt: "Logo Klara Queen",
  name: "Klara Queen",
  ariaLabel: "Strona główna Klara Queen",
};
